module.exports = __webpack_public_path__ + "static/30-d988942688866d931ec30705d06f4a87.png";